<template>
  <div class="warp">
    <div class="warp1">
      <div class="top">
        <div class="top_cent">
          <div class="top_p">
            <div class="top_cent_p">
              <i class="el-icon-location"></i>
              <el-dropdown trigger="click" class="koaa">
                <!-- <span class="el-dropdown-link" v-if="namee == ''">
              天津市
              <i class="el-icon-arrow-down el-icon--right"></i>
                </span>-->
                <span class="el-dropdown-link" v-if="getCitys[citr].city_name">
                  {{getCitys[citr].city_name}}
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown" class="koa">
                  <el-dropdown-item
                    v-for="(item,index) in getCitys"
                    :key="index"
                    @click.native="dropdown(item.id,index)"
                  >{{item.city_name}}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <!-- <i class="el-icon-arrow-down icon"></i> -->
            </div>
            <p>|</p>
            <p style="margin-top:2px;">
              <img src="../../assets/img/top_btn_home.png" alt />
            </p>
            <router-link :to="{name:'login'}" tag="p" style="padding:0;">
              <a href="#" class="aa">商企服首页</a>
            </router-link>
          </div>
          <ul class="top_ul">
            <li @click="dialogVisible = true">
              <a href="#">登录</a>
            </li>
            <li>|</li>
            <li @click="dialogVisible1 = true">
              <a href="#">注册</a>
            </li>
            <li>
              <a href="https://coc.sqifu.com" target="_blank">商会后台</a>
            </li>
            <router-link :to="{path:'/fuwushang'}" tag="li">
              <a href="#">卖家中心</a>
            </router-link>
            <li>
              <a href="http://zf.sqifu.com">政府机构</a>
            </li>
            <li v-if="citr ==0 ">
              <i class="el-icon-phone"></i>022-8821-9596
            </li>
            <li v-if="citr == 1 ">
              <i class="el-icon-phone"></i>0934--8612991
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="cent">
      <img src="../../assets/img/zhengwu/government_bg_top.png" alt />
      <div class="cent_1">
        <p v-if="getCitys[citr].city_name">{{getCitys[citr].city_name}}</p>
      </div>
    </div>
    <div class="cent1">
      <div class="cent1_1">
        <ul>
          <li @click="zhngwu()">
            <a href="#">首页</a>
          </li>
          <li @click="zhitongche()">
            <a href="#">政企直通车</a>
          </li>
          <li @click="business()">
            <a href="#">办事指南</a>
          </li>
          <li @click="shanhui()" style="background: #e40000;">
            <a href="#">商会</a>
          </li>
          <li @click="fuwu()">
            <a href="#">服务</a>
          </li>
          <li @click="guanyu()">
            <a href="#">关于平台</a>
          </li>
        </ul>
      </div>
    </div>

    <!-- 内容 -->
    <div class="content">
      <div class="content_1">
        <div class="content_top">
          <ul>
            <router-link :to="{name:'zhengwu'}" tag="li">
              <a href="#">当前位置：首页</a>
            </router-link>
            <li>
              <i class="el-icon-arrow-right"></i>
            </li>
            <router-link :to="{name:'shanhui'}" tag="li">
              <a href="#">商会</a>
            </router-link>
            <li>
              <i class="el-icon-arrow-right"></i>
            </li>
            <li>
              <a href="#">{{this.name}}</a>
            </li>
          </ul>
        </div>
        <div class="content_zhong">
          <div class="content_zhong_1">
            <div class="content_zhong_2">
              <p class="zhongz_img">
                <img :src="'https://coc.sqifu.com/'+datas.business_logo" alt />
              </p>
              <p class="zhongz_p">{{datas.business_name}}</p>
            </div>
          </div>
          <div class="content_zhong_two">
            <div class="content_zhong_two_1">
              <p class="zhong_two_img">
                <img src="../../assets/img/sh_icon_jbxx.png" alt />
              </p>
              <p class="zhong_two_p">基本信息</p>
            </div>
            <div class="content_zhong_two_2">
              <div class="content_zhong_two_left">
                <div class="content_zhong_two_p">
                  <p>商会属性</p>
                  <p>{{datas.business_attribute}}</p>
                </div>
                <div class="content_zhong_two_p">
                  <p>级别</p>
                  <p>{{datas.level}}</p>
                </div>
                <div class="content_zhong_two_p">
                  <p>地域</p>
                  <p>{{datas.address}}</p>
                </div>
                <div class="content_zhong_two_p">
                  <p>会长姓名</p>
                  <p>{{datas.business_first_name}}</p>
                </div>
                <div class="content_zhong_two_p">
                  <p>商会电话</p>
                  <p>{{datas.contact_phone}}</p>
                </div>

                <div class="content_zhong_two_p">
                  <p>办公地址</p>
                  <p>{{datas.detailed_address}}</p>
                </div>
              </div>
              <div class="content_zhong_two_right" @click="join(datas.id,datas.business_name)">
                <a href="#">申请加入</a>
              </div>
            </div>
          </div>
          <div class="content_zhong_two">
            <div class="content_zhong_two_1">
              <p class="zhong_two_img">
                <img src="../../assets/img/sh_icon_shjj.png" alt />
              </p>
              <p class="zhong_two_p">商会简介</p>
            </div>
            <div class="content_zhong_bottom">
              <div class="content_zhong_bottom_1">
                <p>{{datas.business_introduction}}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="content_botm">
          <div class="content_cent_1">
            <p>商会动态</p>
          </div>
          <ul class="content_botm_ul">
            <li v-for="(item,index) in all" :key="index" @click="idem(item.id)">
              <p>
                <img src="../../assets/img/zhengwu/z_icon_list02.png" alt />
              </p>
              <p>{{item.article_name}}</p>
            </li>
          </ul>
          <div class="content_botm_fenye">
            <el-pagination
              background
              @current-change="handleCurrentChange"
              :current-page="current_page"
              layout="prev, pager, next"
              :total="total"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>
    <!-- di'bu -->
    <div class="floor">
      <div class="floor_1">
        <img src="../../assets/img/bottom_logo_white.png" alt class="img" />
        <ul>
          <li @click="floor">
            <a href="#">关于商企服</a>
          </li>
          <li @click="leimu()">
            <a href="#">商企服服务平台</a>
          </li>
          <li>
            <a href="#">|</a>
          </li>
          <li>
            <a href="#">联系电话：022-8821-9596</a>
          </li>
          <p>Copyright © 1998 - 2019 newcoc. All Rights Reserved.</p>
        </ul>
      </div>
    </div>

    <el-dialog :visible.sync="dialogVisible" width="760px" height="473px">
      <div class="login1">
        <div :class="{active:0==num}" @click="num=0">
          <a href="#">登录</a>
        </div>
        <div :class="{active:1==num}" @click="num=1">
          <a href="#">注册</a>
        </div>
      </div>
      <div class="login1_1" v-show="num==0">
        <img src="../../assets/img/pop_bg_login.png" alt class="login1_img" />
        <div class="login1_2">
          <div class="login1_2_left">
            <div class="login1_2_erro1">
              <div class="login1_2_erro" v-show="cang">
                <img src="../../assets/img/pop_icon_error.png" alt />
                <p>手机号格式错误！</p>
              </div>
            </div>
            <div class="login1_2_login">
              <div class="login1_2_tel">
                <el-form>
                  <el-form-item prop="phone" class="pr">
                    <el-input placeholder="请输入手机号" class="input1" v-model="form.phone"></el-input>
                    <button @click="getCode(form)" class="code-btn" :disabled="!show">
                      <span v-show="show">获取验证码</span>
                      <span v-show="!show" class="count">重新发送({{count}})</span>
                    </button>
                  </el-form-item>
                  <el-form-item class="pr" prop="ecord">
                    <el-input placeholder="请输入验证码" class="input1" v-model="form.ecord"></el-input>
                  </el-form-item>
                </el-form>
              </div>
              <div class="login1_2_denglu" @click="login()">
                <p>
                  <a href="#">登录</a>
                </p>
              </div>
            </div>
          </div>
          <!-- <div class="login1_2_right">
            <img src alt />
          </div>-->
        </div>
      </div>
      <div class="login2_1" v-show="num==1">
        <div class="login2_1_one">
          <div class="login1_2_erro1">
            <div class="login1_2_erro" v-show="cang">
              <img src="../../assets/img/pop_icon_error.png" alt />
              <p>手机号格式错误！</p>
            </div>
          </div>
          <div class="login2_1_two">
            <el-form>
              <el-form-item class="pr" prop="name">
                <el-input placeholder="请输入姓名" class="input1" v-model="formLogon.name"></el-input>
              </el-form-item>
              <el-form-item prop="phone" class="pr">
                <el-input placeholder="请输入手机号" class="input1" v-model="formLogon.phone"></el-input>
                <button @click="getCode1(formLogon)" class="code-btn" :disabled="!show">
                  <span v-show="show">获取验证码</span>
                  <span v-show="!show" class="count">重新发送({{count}})</span>
                </button>
              </el-form-item>
              <el-form-item class="pr" prop="ecord">
                <el-input placeholder="请输入验证码" class="input1" v-model="formLogon.ecord"></el-input>
              </el-form-item>
              <el-form-item class="pr" prop="enterprise_name">
                <el-input placeholder="请输入公司名称" class="input1" v-model="formLogon.enterprise_name"></el-input>
              </el-form-item>
              <el-form-item class="pr">
                <el-cascader
                  :options="options"
                  :props="defaultParams"
                  :change-on-select="true"
                  :clearable="true"
                  v-model="formLogon.office_address_province_id"
                  @change="handleChange"
                  ref="cascaderAddr"
                  style="width:322px"
                ></el-cascader>
              </el-form-item>
              <el-form-item class="pr" prop="detailed_address">
                <el-input
                  placeholder="请输入公司详细地址"
                  class="input1"
                  v-model="formLogon.detailed_address"
                ></el-input>
              </el-form-item>
            </el-form>
            <div class="login_three">
              <img src="../../assets/img/pop_btn_xy_nor.png" @click="munn()" v-show="num1==2" />
              <img src="../../assets/img/pop_btn_xy_sel.png" @click="munn1()" v-show="num1==1" />
              <p>
                我已阅读并同意
                <a href="#" style="color:#007BFF">《商企服平台用户服务协议》</a>
              </p>
            </div>
            <div class="login1_2_denglu" @click="getlogon">
              <p>
                <a href="#">注册</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisible1" width="760px" height="473px">
      <div class="login1">
        <div :class="{active:1==num}" @click="num=1">
          <a href="#">登录</a>
        </div>
        <div :class="{active:0==num}" @click="num=0">
          <a href="#">注册</a>
        </div>
      </div>
      <div class="login1_1" v-show="num==1">
        <img src="../../assets/img/pop_bg_login.png" alt class="login1_img" />
        <div class="login1_2">
          <div class="login1_2_left">
            <div class="login1_2_erro1">
              <div class="login1_2_erro" v-show="cang">
                <img src="../../assets/img/pop_icon_error.png" alt />
                <p>手机号格式错误！</p>
              </div>
            </div>
            <div class="login1_2_login">
              <div class="login1_2_tel">
                <el-form>
                  <el-form-item prop="phone" class="pr">
                    <el-input placeholder="请输入手机号" class="input1" v-model="form.phone"></el-input>
                    <button @click="getCode(form)" class="code-btn" :disabled="!show">
                      <span v-show="show">获取验证码</span>
                      <span v-show="!show" class="count">重新发送({{count}})</span>
                    </button>
                  </el-form-item>
                  <el-form-item class="pr" prop="ecord">
                    <el-input placeholder="请输入验证码" class="input1" v-model="form.ecord"></el-input>
                  </el-form-item>
                </el-form>
              </div>
              <div class="login1_2_denglu" @click="login()">
                <p>
                  <a href="#">登录</a>
                </p>
              </div>
            </div>
          </div>
          <!-- <div class="login1_2_right">
            <img src alt />
          </div>-->
        </div>
      </div>
      <div class="login2_1" v-show="num==0">
        <div class="login2_1_one">
          <div class="login1_2_erro1">
            <div class="login1_2_erro" v-show="cang">
              <img src="../../assets/img/pop_icon_error.png" alt />
              <p>手机号格式错误！</p>
            </div>
          </div>
          <div class="login2_1_two">
            <el-form>
              <el-form-item class="pr" prop="name">
                <el-input placeholder="请输入姓名" class="input1" v-model="formLogon.name"></el-input>
              </el-form-item>
              <el-form-item prop="phone" class="pr">
                <el-input placeholder="请输入手机号" class="input1" v-model="formLogon.phone"></el-input>
                <button @click="getCode1(formLogon)" class="code-btn" :disabled="!show">
                  <span v-show="show">获取验证码</span>
                  <span v-show="!show" class="count">重新发送({{count}})</span>
                </button>
              </el-form-item>
              <el-form-item class="pr" prop="ecord">
                <el-input placeholder="请输入验证码" class="input1" v-model="formLogon.ecord"></el-input>
              </el-form-item>
              <el-form-item class="pr" prop="enterprise_name">
                <el-input placeholder="请输入公司名称" class="input1" v-model="formLogon.enterprise_name"></el-input>
              </el-form-item>
              <el-form-item class="pr">
                <el-cascader
                  :options="options"
                  :props="defaultParams"
                  :change-on-select="true"
                  :clearable="true"
                  v-model="formLogon.office_address_province_id"
                  @change="handleChange"
                  ref="cascaderAddr"
                  style="width:322px"
                ></el-cascader>
              </el-form-item>
              <el-form-item class="pr" prop="detailed_address">
                <el-input
                  placeholder="请输入公司详细地址"
                  class="input1"
                  v-model="formLogon.detailed_address"
                ></el-input>
              </el-form-item>
            </el-form>
            <div class="login_three">
              <img src="../../assets/img/pop_btn_xy_nor.png" @click="munn()" v-show="num1==2" />
              <img src="../../assets/img/pop_btn_xy_sel.png" @click="munn1()" v-show="num1==1" />
              <p>
                我已阅读并同意
                <a href="#" style="color:#007BFF">《商企服平台用户服务协议》</a>
              </p>
            </div>
            <div class="login1_2_denglu" @click="getlogon">
              <p>
                <a href="#">注册</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getBusinessById, getBusinessArticle } from "@/http/api";
import { getLoginphone, getLogin, getRegionList, getLogon } from "@/http/api";
export default {
  data() {
    return {
      value1: "",
      numm: 0,
      datas: [],
      total: 0,
      to: 0,
      current_page: 1,
      all: [],
      //登录
      dialogVisible: false,
      dialogVisible1: false,
      num: 0,
      TIME_COUNT: 60, //验证码倒计时60s
      form: {
        phone: "",
        ecord: ""
      },
      formLogon: {
        phone: "",
        ecord: "",
        name: "",
        enterprise_name: "",
        office_address_province_id: "",
        detailed_address: ""
      },
      count: "",
      show: true,
      cang: false,
      num1: 2,
      options: [],
      defaultParams: {
        label: "name",
        value: "id",
        children: "children"
      },
      //划过
      munn() {
        this.num1 = 1;
      },
      munn1() {
        this.num1 = 2;
      },
      getCitys:[]
    };
  },
  methods: {
    floor() {
      this.$router.push({ path: "/guanyu" });
    },
    // 跳转
    leimu() {
      this.$router.push({ path: "/home" });
    },
    zhitongche() {
      this.$router.push({
        path: "/zhitongche"
      });
    },
    business() {
      this.$router.push({
        path: "/business"
      });
    },
    shanhui() {
      this.$router.push({
        path: "/shanhui"
      });
    },
    guanyu() {
      this.$router.push({
        path: "/guanyupingtai"
      });
    },
    fuwu() {
      this.token = localStorage.getItem("token");
      this.$http(
        "https://coc.sqifu.com/WebProgram/Base/checklogin",
        {
          token: this.token
        },
        "post"
      ).then(res => {
        if (res.data.errcode === 20001) {
           this.$router.push({
            path: "/login"
          });
        } else {
          this.$router.push({
            path: "/home"
          });
        }
      });
    },
    zhngwu() {
      this.$router.push({
        name: "zhengwu"
      });
    },
    getBusinessbyId(id) {
      getBusinessById({
        id: id
      }).then(res => {
        this.datas = res.data.data;
      });
    },
    getBusinessarticle(id, page) {
      getBusinessArticle({
        id: id,
        page: page
      }).then(res => {
        console.log(res);
        this.all = res.data.data.list;
        this.total = parseInt(res.data.data.count);
      });
    },
    handleCurrentChange(current_page) {
      this.current_page = current_page;
      var id = this.$route.query.ids;
      this.getBusinessarticle(id, current_page);
    },
    //登录
    getCode(form) {
      if (!/^1[34578]\d{9}$/.test(this.form.phone)) {
        this.cang = !this.cang;
      } else if (/^1[34578]\d{9}$/.test(this.form.phone)) {
        this.cang = false;
        getLoginphone({ phone: this.form.phone }).then(res => {
          console.log(res);
        });
        if (!this.timer) {
          this.count = this.TIME_COUNT;
          this.show = false;
          this.timer = setInterval(() => {
            if (this.count > 0 && this.count <= this.TIME_COUNT) {
              this.count--;
            } else {
              this.show = true;
              clearInterval(this.timer);
              this.timer = null;
            }
          }, 1000);
        }
      }
    },
    login() {
      if (this.form.ecord == "") {
        this.$message({
          message: "请输入验证码"
        });
      } else {
        getLogin({
          phone: this.form.phone,
          ecord: this.form.ecord
        }).then(res => {
          console.log(res);
          this.login_login = res.data;
          console.log(this.login_login);
          if (res.data.errcode === 200) {
            this.dialogVisible = false;
            this.$message({
              message: "登录成功",
              type: "success"
            });
            this.$router.push({
              name: "home",
              query: {
                id: res.data.data.name,
                idimg: res.data.data.photo,
                token: res.data.data.token
              }
            });
            localStorage.setItem("name", res.data.data.name);
            localStorage.setItem("token", res.data.data.token);
            localStorage.setItem("phone", res.data.data.phone);
            localStorage.setItem("photo", res.data.data.photo);
            localStorage.setItem("member_id", res.data.data.member_id);
            localStorage.setItem("is_service", res.data.data.is_service);
          } else if (res.data.errcode == 406) {
            this.$message({
              message: "账号信息不存在，请先注册"
            });
          }
        });
      }
    },
    //注册并登录
    getCode1(formLogon) {
      if (!/^1[34578]\d{9}$/.test(this.formLogon.phone)) {
        this.cang = !this.cang;
      } else if (/^1[34578]\d{9}$/.test(this.formLogon.phone)) {
        this.cang = false;
        getLoginphone({ phone: this.formLogon.phone }).then(res => {
          console.log(res);
        });
        if (!this.timer) {
          this.count = this.TIME_COUNT;
          this.show = false;
          this.timer = setInterval(() => {
            if (this.count > 0 && this.count <= this.TIME_COUNT) {
              this.count--;
            } else {
              this.show = true;
              clearInterval(this.timer);
              this.timer = null;
            }
          }, 1000);
        }
      }
    },
    getlogon() {
      getLogon({
        name: this.formLogon.name,
        phone: this.formLogon.phone,
        ecord: this.formLogon.ecord,
        enterprise_name: this.formLogon.enterprise_name,
        office_address_province_id: this.formLogon.office_address_province_id,
        detailed_address: this.formLogon.detailed_address
      }).then(res => {
        this.logon_logon = res.data.errcode;
        if (res.data.errcode == 200) {
          this.$router.push({
            name: "home",
            query: {
              id: this.formLogon.name
            }
          });
          localStorage.setItem("name", this.formLogon.name);
          localStorage.setItem("is_service", res.data.data.is_service);
        }
        if (res.data.errcode === 20001) {
          this.$message({
            message: "该手机号已经是会员",
            type: "success"
          });
        }
      });
    },
    handleChange(value) {
      console.log(value);
      let labels = this.$refs["cascaderAddr"].currentLables;
      console.log(this.$refs["cascaderAddr"]);
    },
    getRegion() {
      getRegionList({}).then(res => {
        console.log(res);
        this.options = res.data.data;
      });
    },
    checlogin() {
      this.token = localStorage.getItem("token");
      this.$http(
        "https://coc.sqifu.com/WebProgram/Base/checklogin",
        {
          token: this.token
        },
        "post"
      ).then(res => {
        if (res.data.errcode === 20001) {
          this.$emit("header", false); //是否显示头部
        } else {
          this.$emit("header", true); //是否显示头部
        }
      });
    },
    join(id, business_name) {
      this.token = localStorage.getItem("token");
      this.$http(
        "https://coc.sqifu.com/WebProgram/Base/checklogin",
        {
          token: this.token
        },
        "post"
      ).then(res => {
        if (res.data.errcode === 20001) {
          alert("请先登录");
        } else {
          this.$router.push({
            name: "joinshanhui",
            query: {
              id: id,
              name: business_name
            }
          });
        }
      });
    },
    idem(id) {
      this.$router.push({
        name: "adtitle",
        query: {
          citys: id
        }
      });
    },
    getCity() {
      this.$http("https://ctapi.sqifu.com/api/v1/getCityList", {}, "post").then(
        res => {
          this.getCitys = res.data.data;
        }
      );
    },
    dropdown(id, index) {
      this.citr = index;
      localStorage.setItem("city_id", id);
      localStorage.setItem("citr", this.citr);
      this.$router.go(0);
    }
  },
  created() {
    var id = this.$route.query.ids;
    this.name = this.$route.query.name;
    this.getBusinessbyId(id);
    this.getBusinessarticle(id);
    this.getRegion(); //城市
    this.checlogin();
    this.citr = localStorage.getItem("citr");
    this.getCity();
  }
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  list-style: none;
  text-decoration: none;
}

.warp {
  width: 100%;
  height: auto;
  position: relative;
  overflow: hidden;
}

.top {
  width: 100%;
  background: #f5f6fa;
}

.top_cent {
  width: 1200px;
  height: 40px;
  margin: 0 auto;
}

.aa {
  color: #222222;
}

.top_p {
  font-size: 14px;
  color: #222222ff;
  line-height: 40px;
  float: left;
}

.top_p p {
  float: left;
  padding: 0 12px;
}

.top_cent_p {
  color: #007bffff;
  float: left;
}

.icon {
  color: #000;
}

.top_ul {
  width: auto;
  height: auto;
  display: flex;
  float: right;
}

.top_ul li {
  font-size: 14px;
  line-height: 40px;
  color: #666666;
  margin-left: 39px;
}
.warp1 {
  width: 100%;
  margin: 0 auto;
  z-index: 1;
  overflow: hidden;
  min-width: 1200px;
}

.floor {
  width: 100%;
  height: 139px;
  background: #2d3236;
  overflow: hidden;
}

.floor_1 {
  width: 1200px;
  height: auto;
  margin: 0 auto;
}

.img {
  padding: 54px 0;
  float: left;
}

.floor_1 ul {
  width: 480px;
  height: 96px;
  float: right;
  padding: 44px 0;
}

.floor_1 ul li a {
  float: left;
  padding: 0 0 0 33px;
  color: #ffffff;
  font-size: 14px;
}
.floor_1 ul p {
  font-size: 14px;
  font-weight: 400;
  float: right;
  color: #85919aff;
  padding: 20px 0;
}

.cent {
  width: 100%;
  height: 96px;
  position: relative;
}

.cent img {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
}

.cent_1 {
  width: 1200px;
  height: 96px;
  margin: 0 auto;
}

.cent_1 p {
  font-size: 32px;
  color: #fff;
  line-height: 96px;
  font-weight: 600;
}

.cent1 {
  width: 100%;
  height: 40px;
  background: #1369c0;
}

.cent1_1 {
  width: 1200px;
  height: 40px;
  margin: 0 auto;
}

.cent1_1 ul li {
  float: left;
  width: 199px;
  height: 40px;
  border-right: 1px solid #71a5d9;
  line-height: 40px;
  text-align: center;
}

.cent1_1 ul li:hover {
  background: #e40000;
  height: 40px;
  margin: 0;
  line-height: 40px;
}

.cent1_1 ul li a {
  width: 200px;
  color: #fff;
}

.cent1_1 ul li:nth-child(6) {
  border: 0;
}

.content {
  width: 100%;
  height: auto;
  position: relative;
}

.content_1 {
  width: 1200px;
  height: auto;
  margin: 0 auto;
}

.content_one {
  width: 100%;
  height: 36px;
  margin: 30px 0;
}

.content_top {
  width: 1200px;
  height: 40px;
  background: rgba(244, 245, 249, 1);
  border: 1px solid rgba(228, 228, 228, 1);
  border-radius: 2px;
  margin-bottom: 46px;
}

.content_top ul {
  padding: 0 10px;
}

.content_top ul li {
  float: left;
  color: #666666;
  line-height: 40px;
  margin-left: 5px;
}

.content_top ul li a {
  color: #666666;
}

.content_zhong {
  width: 1200px;
  height: 673px;
}

.content_zhong_1 {
  width: 100%;
  height: 100px;
  border-bottom: 1px solid #e4e4e4;
  text-align: center;
}

.content_zhong_2 {
  width: 100%;
  text-align: center;
}

.zhongz_img {
  width: 67px;
  height: 67px;
  float: left;
}

.zhongz_img img {
  width: 67px;
  height: 67px;
}

.zhongz_p {
  float: left;
  font-size: 34px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(34, 34, 34, 1);
  line-height: 67px;
  padding: 0 10px;
}

.content_zhong_two {
  width: 100%;
  height: 241px;
  border-bottom: 1px solid #e4e4e4;
}

.content_zhong_two_1 {
  width: 191px;
  height: 241px;
  border-right: 1px solid #e4e4e4;
  line-height: 241px;
  float: left;
}

.zhong_two_img img {
  float: left;
  width: 34px;
  height: 34px;
  margin: 103px 11px;
}

.zhong_two_p {
  font-size: 26px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666666;
}

.content_zhong_two_2 {
  width: 1008px;
  height: 241px;
  float: left;
  overflow: hidden;
}

.content_zhong_two_left {
  width: 600px;
  height: 241px;
  float: left;
}

.content_zhong_two_p {
  margin: 18px 0;
  overflow: hidden;
}

.content_zhong_two_p p:first-child {
  width: 105px;
  height: 18px;
  float: left;
  text-align: right;
  margin-right: 20px;
  color: #999999;
}

.content_zhong_two_p p:last-child {
  width: 400px;
  height: 18px;
  float: left;
}

.content_zhong_two_right {
  width: 180px;
  height: 44px;
  background: #f7681e;
  float: right;
  text-align: center;
  line-height: 44px;
  margin: 99px 0;
  border-radius: 4px;
}

.content_zhong_two_right a {
  color: #fff;
}

.content_zhong_bottom {
  width: 1008px;
  height: 241px;
  overflow: hidden;
}

.content_zhong_bottom_1 {
  width: 969px;
  height: 251px;
  margin: 10px auto;
}

.content_zhong_bottom_1 p {
  letter-spacing: 0.5px;
  text-indent: 30px;
  line-height: 25px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 9;
  -webkit-box-orient: vertical;
  word-break: break-all;
}

.content_botm {
  width: 100%;
  height: 600px;
}

.content_botm_ul {
  width: 100%;
  height: 400px;
  margin-bottom: 30px;
}
.content_botm_ul li {
  width: 1200px;
  height: 50px;
}

.content_botm_ul li p {
  line-height: 50px;
  padding: 0 5px;
  float: left;
  font-size: 18px;
}

.content_botm_ul li:nth-child(2n) {
  background: #f4f5f9;
}

.content_botm_fenye {
  width: 437px;
  height: 36px;
  float: right;
}

.content_cent_1 {
  width: 100%;
  height: 36px;
  border-bottom: 1px solid rgba(196, 210, 237, 1);
  margin-bottom: 30px;
}

.content_cent_1 p {
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: rgba(19, 105, 192, 1);
}

/* denglu */
.login1 {
  width: 340px;
  height: 50px;
  margin: 0 auto;
}

.login1 div {
  width: 170px;
  height: 40px;
  font-size: 18px;
  float: left;
  text-align: center;
  font-weight: bold;
  border-bottom: 2px solid #e4e4e4;
}

.login1 div a {
  color: #a9a9a9;
}

.login1 div.active {
  border-bottom: 2px solid #007bff;
}

.login1 div.active a {
  color: #007bff;
}

.login1_1 {
  width: 100%;
  height: 399px;
  position: relative;
  overflow: hidden;
}

.login1_img {
  position: absolute;
  right: 0;
  bottom: 0;
}

.login1_2 {
  width: 604px;
  height: 239px;
  margin: 50px auto;
}

.login1_2_left {
  width: 332px;
  height: auto;
  margin: 0 auto;
}

.login1_2_erro {
  width: 322px;
  height: 30px;
  border: 1px solid#FF4D42;
  background: rgba(255, 77, 66, 0.1);
  line-height: 30px;
  margin-bottom: 16px;
}

.login1_2_erro1 {
  width: 322px;
  height: 30px;
  margin-bottom: 16px;
}

.login1_2_erro img {
  float: left;
  padding: 5px 9px;
}

.login1_2_login {
  width: 322px;
  height: 168px;
}

.inp {
  width: 210px;
  height: 40px;
  font-size: 14px;
  float: left;
  outline: 0;
  border: 0;
  margin: 0 5px;
}

.login1_2_tel {
  width: 100%;
  height: auto;
  margin-bottom: 30px;
  position: relative;
}

.inpt {
  width: 312px;
  height: 38px;
  outline: 0;
  font-size: 14px;
  border: 0;
  margin: 0 5px;
}

.login1_2_right {
  float: right;
  background: #000;
  width: 228px;
  height: 239px;
}

.login1_2_denglu {
  width: 100%;
  height: 40px;
  background: #007bff;
  margin-top: 32px;
}

.login1_2_denglu p {
  text-align: center;
  font-size: 16px;
  line-height: 40px;
}

.login1_2_denglu p a {
  color: #fff;
}
.code-btn {
  width: 100px;
  height: 20px;
  position: absolute;
  top: 10px;
  right: 5px;
  z-index: 222;
  color: #007bff;
  font-size: 14px;
  border: none;
  border-left: 1px solid #bababa;
  padding-left: 10px;
  background-color: #fff;
  cursor: pointer;
  outline: none;
}
.pr {
  margin-bottom: 20px;
}

.login2_1_one {
  width: 322px;
  height: 550px;
  margin: 20px auto;
}

.login_three {
  width: 100%;
  height: 20px;
  margin-bottom: 20px;
}

.login_three img {
  float: left;
  padding: 0 5px 0 0;
}

.login_three p {
  float: left;
  line-height: 15px;
}

.top_ul li a {
  color: #666666;
}
</style>
 


// WEBPACK FOOTER //
// src/view/Zhengwu/Shanhuiming.vue